var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBehanceLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_720_1142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z",
    fill: "#4176FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0163 11.5656C14.9726 11.5656 14.9674 15.5941 14.9674 15.6148C14.9674 15.6148 14.6904 19.6482 19.0163 19.6482C19.0163 19.6482 22.624 19.8534 22.624 16.8412H20.7715C20.7715 16.8412 20.8329 17.9752 19.078 17.9752C19.078 17.9752 17.2254 18.0985 17.2254 16.1431H22.6856C22.6856 16.1431 23.2861 11.5656 19.0163 11.5656ZM17.2047 14.7318C17.2047 14.7318 17.4306 13.1102 19.0575 13.1102C20.6894 13.1102 20.6637 14.7318 20.6637 14.7318H17.2047ZM12.5763 13.6954C12.5763 13.6954 14.1825 13.5774 14.1825 11.6889C14.1825 9.80572 12.8688 8.88184 11.201 8.88184H5.71484V19.4274H11.2005C11.2005 19.4274 14.5516 19.5302 14.5516 16.3126C14.5519 16.3126 14.6956 13.6954 12.5763 13.6954ZM8.13211 10.7548H11.2007C11.2007 10.7548 11.9449 10.7548 11.9449 11.8529C11.9449 12.951 11.5087 13.1102 11.0108 13.1102H8.13211V10.7548ZM11.047 17.5544H8.13211V14.7318H11.2007C11.2007 14.7318 12.3145 14.7216 12.3093 16.1841C12.3093 17.4159 11.4832 17.5442 11.047 17.5544ZM16.748 9.50275V10.8012H21.0999V9.50275H16.748Z",
    fill: "#F1F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_720_1142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehanceLogo);
export default __webpack_public_path__ + "static/media/behance-logo.495962c36c7fc814cfd5dbfc2b19e4f6.svg";
export { ForwardRef as ReactComponent };